window.addEventListener('swishlist:st-wishlist-add-to-cart', async () => {
  try {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) return;

    const cart = await response.json();

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'swishlist',
          data: {
            source: 'swishlist',
            itemCount: cart.item_count,
          },
        },
      })
    );
  } catch (error) {
    console.error('[swishlist-cart-bridge] Failed to refresh cart:', error);
  }
});